<script>
    import UTILS from "./classes/utilities.js";

    import ProductOrders from "./ProductOrders.svelte";

    export let productsOrders = [];
    export let supplements = [];
    let totalPrice = 0.0;

    function getTotalPrice() {
        // FIXME: weird function call with side effect
        totalPrice = productsOrders.reduce((sum, v) => sum + v.getPrice(), 0);
        return totalPrice;
    }
    getTotalPrice();

    function getTotalOrder() {
		return productsOrders.reduce((total, n) => total + n.getPrice(), 0);
	}

    function sendOrder() {
        const root = `PROXY_URL`;
        console.log('productsOrders[0]', productsOrders[0]);

        let orders = productsOrders.filter((v) => {return v.isBillable();});
        console.log('orders', orders);
        let payload = {
            name: 'FRONTEND (svelte)',
            table: 'Tafel 001',
            totalPrice: getTotalPrice(),
            products: [],
        };

        let products = [];
        orders.forEach((a) => {
            // FIXME a is an array
            let v = a[0]
            console.log(v);
            let product = {
                'order': 'OXO:' + v.id,
                'id': v.id,
                'name': v.product.name,
                'description': v.product.name,
                'price': '' + v.product.price,
                'vat': '' + v.product.vat,
                'amount' : v.quantity,
                'modifiers': [],
            }
            products.push(product);
        });
        payload.products = products;
        console.log('Payload', JSON.stringify(payload,null, 2));
        //return;
        const g = fetch(root + '/order', {
        method: "POST",
        // headers: {
        //     "Content-Type": "application/json",
        //     "X-Access-Token": "token",
        // },
        body: JSON.stringify(payload),
    }).then((result) => {
            console.log('Receipt.svelte', 'Success', result);
        })
        .catch((error) => {
            console.log('Receipt.svelte', 'Failure', error);
        })
        .finally(() => {
            console.log("Done trying to post order");
        })
    }
</script>
<div class="order-total">
	<span class="price">{UTILS.formatMoney(getTotalOrder())}</span>
    <button
        class="order"
        on:click="{() => sendOrder()}"
    >Bestel</button>
</div>
<!--
FIXME: there are no events when changing amount.
-->
{#each productsOrders as productOrders}
    {#if productOrders.isBillable()}
        <ProductOrders {productOrders} {supplements} />
        <div>{productOrders.product.name}</div>
        <div>{productOrders.getPrice()}</div>
        <div>{productOrders.getShortDescription()}</div>
    {/if}
{/each}

<style>
    .order-total {
        display: flex;
        font-weight: bolder;
        font-size: 2em;
    }
    button.order {
        color: black;
        background: green;
    }
</style>
